"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineSlots = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _utils = require("../../../lib/utils");
var _styles = require("../../styles");
const propTypes = {
  linkTarget: _propTypes.string,
  onTimeSlotsClick: _propTypes.func,
  providerId: _propTypes.number.isRequired,
  shouldDisplayAsOnMobile: _propTypes.bool,
  slotsData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    date: _propTypes.string.isRequired,
    href: _propTypes.string,
    time: _propTypes.string.isRequired
  })).isRequired,
  locationName: _propTypes.string.isRequired,
  slotsAriaLabel: _propTypes.func,
  shouldRenderSlotsAsButtons: _propTypes.bool
};
const defaultProps = {
  linkTarget: null,
  onTimeSlotsClick: () => {},
  shouldDisplayAsOnMobile: false,
  slotsAriaLabel: () => undefined,
  shouldRenderSlotsAsButtons: false
};
const InlineSlots = _ref => {
  let {
    linkTarget,
    onTimeSlotsClick,
    providerId,
    shouldDisplayAsOnMobile,
    slotsData,
    locationName,
    slotsAriaLabel,
    shouldRenderSlotsAsButtons
  } = _ref;
  return (0, _map.default)(slotsData).call(slotsData, _ref2 => {
    let {
      date,
      href,
      time,
      count
    } = _ref2;
    let ariaLabel = slotsAriaLabel(date, time, locationName);
    if (count != null) {
      ariaLabel = slotsAriaLabel(date, time, locationName, count);
    }
    let linkProps = {};
    if (!shouldRenderSlotsAsButtons) {
      linkProps = {
        href,
        target: linkTarget,
        rel: (0, _utils.getLinkRel)(linkTarget)
      };
    }
    return /*#__PURE__*/_react.default.createElement(_styles.InlineSlot, (0, _extends2.default)({
      key: `${date}-${time}`,
      as: shouldRenderSlotsAsButtons ? 'button' : 'a',
      onClick: event => onTimeSlotsClick(date, time, providerId, href, event),
      shouldDisplayAsOnMobile: shouldDisplayAsOnMobile,
      "aria-label": ariaLabel
    }, linkProps), `${date} - ${time}`);
  });
};
exports.InlineSlots = InlineSlots;
InlineSlots.defaultProps = defaultProps;
InlineSlots.propTypes = propTypes;